<!-- CABECERA de la sección, no una tarjeta: un recuadro dentro del recuadro del tablero compite
     con lo que viene abajo. La jerarquía la dan el tamaño, el espacio y la regla del final — que es
     la propia barra de avance, así el separador además informa. -->
<section class="sb" *ngIf="sprint as s">
  <div class="sb-head">
    <div class="sb-id">
      <!-- El punto dice «esto está corriendo». Sobre un sprint planeado sería falso. -->
      <span class="sb-live" [class.over]="!esPlaneado && daysLeft !== null && daysLeft < 0" [class.idle]="esPlaneado"></span>
      <h2 class="sb-name">Sprint {{ s.number }}</h2>
      <span class="sb-alias" *ngIf="s.name">{{ s.name }}</span>
    </div>

    <div class="sb-when">
      <span class="sb-range">{{ s.startDate | date: 'dd MMM':'UTC' }} → {{ s.endDate | date: 'dd MMM':'UTC' }}</span>
      <span class="sb-left" [class.over]="daysLeft !== null && daysLeft < 0">{{ daysLabel }}</span>
    </div>

    <button type="button" class="sb-cog" *ngIf="isDev" (click)="openConfig()" title="Configurar el sprint">
      <i class="fa-solid fa-gear"></i>
    </button>
  </div>

  <!-- El objetivo va ANTES de las cifras: explica lo que las cifras miden. -->
  <p class="sb-goal" *ngIf="s.goal">{{ s.goal }}</p>

  <!-- Antes de arrancar no hay nada entregado que medir: lo que importa es qué se va a congelar
       al activar. Mostrar «0/— pts entregados» sobre un sprint que no ha empezado se lee como un
       fracaso en vez de como una promesa. -->
  <!-- Las cifras a la izquierda y el buscador por folio al final del renglón: es la misma altura
       de lectura, y así no se le roba una fila a las columnas. -->
  <div class="sb-meta">
  <div class="sb-stats" *ngIf="esPlaneado">
    <span class="sb-stat"><b>{{ cargaPlaneada.puntos }}</b> pts por comprometer</span>
    <span class="sb-stat"><b>{{ cargaPlaneada.tareas }}</b> tareas</span>
    <span class="sb-stat warn" *ngIf="cargaPlaneada.sinEstimar">
      <b>{{ cargaPlaneada.sinEstimar }}</b> sin estimar — no contarán para el compromiso
    </span>
  </div>

  <!-- Sin compromiso registrado no hay denominador, y decirlo con «—» es más honesto que un 0,
       que se lee como "no hicimos nada". -->
  <div class="sb-stats" *ngIf="!esPlaneado && summary as m">
    <span class="sb-stat">
      <b>{{ m.deliveredPoints }}</b><i>/{{ m.committedPoints ?? '—' }}</i> pts entregados
    </span>
    <span class="sb-stat"><b>{{ m.deliveredCount }}</b> tareas entregadas</span>
    <!-- Lo que falta por entregar. Antes contaba también lo ya entregado y sin liberar, así que el
         tablero decía "N abiertas" incluyendo tareas terminadas. -->
    <span class="sb-stat warn" *ngIf="m.openCount"><b>{{ m.openCount }}</b> sin entregar</span>
    <span class="sb-stat" *ngIf="m.pendingRelease"><b>{{ m.pendingRelease }}</b> esperan deploy</span>
  </div>

  <form class="sb-find" role="search" (ngSubmit)="buscarFolio()">
    <i class="fa-solid" [class.fa-magnifying-glass]="!buscandoFolio" [class.fa-spinner]="buscandoFolio" [class.fa-spin]="buscandoFolio"
      aria-hidden="true"></i>
    <input type="search" name="folio" [(ngModel)]="folioQuery" placeholder="Buscar folio · F-098" aria-label="Buscar una tarea por folio"
      autocomplete="off" spellcheck="false" [disabled]="buscandoFolio" />
  </form>
  </div>

  <!-- La regla que cierra la cabecera. Siempre está —es el separador—; se rellena solo cuando hay
       línea base contra la cual medir. -->
  <div class="sb-rule">
    <div class="sb-fill" *ngIf="progressPct !== null" [style.width.%]="progressPct"></div>
  </div>
</section>

<!-- Ni activo ni planeado: no hay ningún sprint registrado. Antes este mensaje también salía con
     un sprint planeado esperando —el tablero solo cargaba el activo— y dejaba sin salida al que
     venía a arrancarlo. -->
<div class="sb sb-none" *ngIf="!sprint">
  <i class="fa-solid fa-flag-checkered"></i>
  <span>No hay ningún sprint registrado, ni en curso ni en planeación.</span>
</div>

<!-- ─────────── Configuración ─────────── -->
<p-dialog [(visible)]="configVisible" [modal]="true" [closable]="true" [style]="{ width: '580px' }"
  [breakpoints]="{ '640px': '94vw' }" [header]="configTitle" styleClass="wl-sprint-dialog">
  <div class="sc" *ngIf="sprint as s">
    <!-- Cómo se nombra: lo que el resto del panel va a leer -->
    <section class="sc-sec">
      <h4 class="sc-sec-t">Cómo se nombra</h4>

      <div class="wl-field">
        <label>Objetivo corto</label>
        <input type="text" pInputText [(ngModel)]="form.name" maxlength="60"
          placeholder="Ej. Centralización del tablero" />
        <small class="hint">Acompaña al número en todo el panel: «Sprint {{ s.number }} · {{ form.name || '…' }}».</small>
      </div>

      <div class="wl-field">
        <label>Qué se busca este sprint</label>
        <textarea pInputTextarea [(ngModel)]="form.goal" rows="3"
          placeholder="Un par de renglones: qué se cierra y por qué importa."></textarea>
        <small class="hint">Se muestra sobre las columnas del tablero.</small>
      </div>
    </section>

    <!-- Ventana: la duración se calcula a la vista para no contar días en el calendario -->
    <section class="sc-sec">
      <h4 class="sc-sec-t">
        Ventana
        <span class="sc-sec-x" *ngIf="rangeLabel">{{ rangeLabel }}</span>
      </h4>

      <!-- La cadencia es fija —dos semanas, lunes a viernes— así que el fin se DERIVA del inicio.
           Teclearlo era una oportunidad de equivocarse sin ninguna decisión detrás. -->
      <div class="wl-row">
        <div class="wl-field">
          <label>Arranca el lunes</label>
          <p-calendar [ngModel]="form.startDate" (ngModelChange)="onStartChange($event)" dateFormat="dd/mm/yy"
            appendTo="body" styleClass="w-full"></p-calendar>
        </div>
        <div class="wl-field">
          <label>Cierra el viernes <span class="lbl-hint">automático</span></label>
          <div class="sc-fin" [class.off]="fueraDeCadencia">{{ finLabel }}</div>
        </div>
      </div>

      <small class="hint" *ngIf="startAdjusted">
        <i class="fa-solid fa-wand-magic-sparkles"></i>
        Se movió al lunes de esa semana: los sprints arrancan en lunes para que las quincenas se puedan comparar.
      </small>
      <small class="hint" *ngIf="!startAdjusted && !fueraDeCadencia">Dos semanas de trabajo: del lunes al viernes siguiente.</small>

      <!-- Este sprint se guardó antes de que la cadencia existiera. Se dice y se ofrece el
           arreglo; corregirlo solo al abrir el diálogo cambiaría la ventana sin que nadie lo pida. -->
      <small class="warn" *ngIf="fueraDeCadencia && cadenciaPropuesta as v">
        <i class="fa-solid fa-triangle-exclamation"></i>
        Esta ventana no sigue la cadencia de lunes a viernes.
        <button type="button" class="sc-fixlink" (click)="ajustarCadencia()">Ajustarla</button>
      </small>
      <small class="err" *ngIf="rangeError"><i class="fa-solid fa-triangle-exclamation"></i> {{ rangeError }}</small>
    </section>


    <!-- Ciclo de vida: irreversible, así que se separa del formulario y confirma antes -->
    <section class="sc-life" *ngIf="!confirming">
      <div class="sc-life-txt">
        <span class="sc-state" [class]="'is-' + s.status">
          <i class="fa-solid" [ngClass]="stateIcon"></i> {{ stateLabel }}
        </span>
        <p>{{ stateHint }}</p>
      </div>

      <button type="button" class="wl-btn ghost" *ngIf="s.status === 'planned'" (click)="confirming = 'activate'">
        <i class="fa-solid fa-play"></i> Activar
      </button>
      <button type="button" class="wl-btn ghost danger-text" *ngIf="s.status === 'active'" (click)="confirming = 'close'">
        <i class="fa-solid fa-flag-checkered"></i> Cerrar
      </button>
    </section>

    <div class="sc-confirm" *ngIf="confirming">
      <ng-container *ngIf="confirming === 'close'">
        <p><strong>Cerrar el sprint sella sus métricas.</strong> Un sprint cerrado no se reabre.</p>

        <!-- Qué se queda y qué se va, contado sobre el tablero AHORA. Sin esto, «lo abierto se
             arrastra al siguiente» es una frase: no dice cuánto ni de dónde. -->
        <div class="sc-cierre">
          <div class="sc-c-item">
            <span class="sc-c-n done">{{ cierre.terminadas }}</span>
            <span class="sc-c-k">entregadas</span>
            <span class="sc-c-h">se quedan en el {{ sprint ? 'Sprint ' + sprint.number : 'sprint' }}</span>
          </div>
          <div class="sc-c-item">
            <span class="sc-c-n move">{{ cierre.enCurso }}</span>
            <span class="sc-c-k">en curso</span>
            <span class="sc-c-h">pasan al siguiente donde están</span>
          </div>
          <div class="sc-c-item">
            <span class="sc-c-n move">{{ cierre.porHacer }}</span>
            <span class="sc-c-k">por hacer</span>
            <span class="sc-c-h">pasan al siguiente sin arrancar</span>
          </div>
        </div>

        <!-- Lo que espera en To Deploy casi siempre ya salió: el deploy ocurre y nadie mueve las
             tarjetas. Pero liberar no se deshace, así que se pregunta y no se asume. -->
        <fieldset class="sc-release" *ngIf="cierre.porLiberar">
          <legend>
            <i class="fa-solid fa-rocket"></i>
            <strong>{{ cierre.porLiberar }} {{ cierre.porLiberar === 1 ? 'tarea espera' : 'tareas esperan' }} en To Deploy.</strong>
            ¿Ya están en producción?
          </legend>
          <label class="sc-r-opt" [class.on]="liberarAlCerrar === true">
            <input type="radio" name="liberarAlCerrar" [value]="true" [(ngModel)]="liberarAlCerrar" />
            <span><b>Sí, pasarlas a Terminadas</b><small>Se quedan en el Sprint {{ s.number }} como liberadas.</small></span>
          </label>
          <label class="sc-r-opt" [class.on]="liberarAlCerrar === false">
            <input type="radio" name="liberarAlCerrar" [value]="false" [(ngModel)]="liberarAlCerrar" />
            <span><b>No, siguen pendientes</b><small>Pasan al siguiente sprint en To Deploy.</small></span>
          </label>
        </fieldset>

        <p class="sc-next" *ngIf="proximaVentana as v">
          <i class="fa-regular fa-calendar-check"></i>
          <span>El siguiente arranca el <strong>{{ v.inicio }}</strong> y cierra el <strong>{{ v.fin }}</strong>.</span>
        </p>
      </ng-container>
      <p *ngIf="confirming === 'activate'">
        <strong>Activar congela el compromiso</strong> como línea base del burndown. No se puede rehacer.
      </p>
      <div class="sc-confirm-actions">
        <button type="button" class="wl-btn ghost" (click)="confirming = null">Volver</button>
        <button type="button" class="wl-btn" [class.danger]="confirming === 'close'" [class.primary]="confirming === 'activate'"
          [disabled]="saving || !puedeConfirmar" (click)="confirm()">
          {{ confirming === 'close' ? 'Sí, cerrar' : 'Sí, activar' }}
        </button>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button type="button" class="wl-btn ghost" (click)="configVisible = false">Cancelar</button>
    <button type="button" class="wl-btn primary" [disabled]="saving || !!rangeError" (click)="save()">
      <i class="fa-solid" [class.fa-check]="!saving" [class.fa-spinner]="saving" [class.fa-spin]="saving"></i>
      Guardar
    </button>
  </ng-template>
</p-dialog>
